import { error as errorReducer } from './Error.reducer';
import {
    PAYMENTS_RECEIVE,
    PAYMENTS_ERROR
} from '../Actions/Payments.action';

const defaultState = {
    errors: {}
};

export const payments = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case PAYMENTS_RECEIVE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case PAYMENTS_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
